import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import type { RootState } from '~/redux/store';

export function Home() {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );

  return <Navigate to={isAuthenticated ? '/dashboard' : '/signin'} replace />;
}
